import accessLocalStorage from './accessLocalStorage';
import axios from 'axios';

// === DRY: Factory for API requests ===

async function fail2banRequest(method, endpoint, data = null, extraHeaders = null) {
  const { token, ipRequest } = accessLocalStorage.getUserLocalStorage();
  const headers = { Authorization: token, ...(extraHeaders || {}) };
  const config = { headers };
  const url = `${ipRequest}api/security/fail2ban/${endpoint}`;

  switch (method) {
    case 'get':
      return (await axios.get(url, config)).data;
    case 'post':
      return (await axios.post(url, data, config)).data;
    case 'put':
      return (await axios.put(url, data, config)).data;
    case 'delete':
      return (await axios.delete(url, config)).data;
    default:
      throw new Error(`Metodo HTTP nao suportado: ${method}`);
  }
}

function qs(params) {
  return Object.entries(params || {})
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
}

// === System-level (root only) ===

export const getFail2banStatus = () => fail2banRequest('get', '');

export const getBannedIPs = () => fail2banRequest('get', 'banned');

export const banIP = (jail, ip) => fail2banRequest('post', 'ban', { jail, ip });

export const unbanIP = (jail, ip) => fail2banRequest('post', 'unban', { jail, ip });

export const getWhitelist = () => fail2banRequest('get', 'whitelist');

export const addToWhitelist = (ip) => fail2banRequest('post', 'whitelist', { ip });

export const removeFromWhitelist = (ip) => fail2banRequest('post', 'whitelist/remove', { ip });

// === Tenant-level (self-service) ===

export const getMyIP = () => fail2banRequest('get', 'my-ip');

export const getTenantWhitelist = (tenant) => fail2banRequest('get', `tenant/${tenant}/whitelist`);

export const addTenantAddress = (tenant, address, reason) =>
  fail2banRequest('post', `tenant/${tenant}/whitelist`, { address, reason });

export const removeTenantAddress = (tenant, id) =>
  fail2banRequest('delete', `tenant/${tenant}/whitelist/${id}`);

// === Auto-block (root only) ===

export const getAutoBlockConfig = () =>
  fail2banRequest('get', 'auto-block/config');

export const updateAutoBlockConfig = (payload, version) =>
  fail2banRequest('put', 'auto-block/config', payload, { 'If-Match': String(version) });

export const triggerAutoBlockKillSwitch = (reason) =>
  fail2banRequest('post', 'auto-block/config/kill-switch', { reason });

export const getAutoBlockActiveBans = () =>
  fail2banRequest('get', 'auto-block/events/active');

export const getAutoBlockHistory = (params) =>
  fail2banRequest('get', `auto-block/events/history?${qs(params)}`);

export const getAutoBlockStats = (days = 7) =>
  fail2banRequest('get', `auto-block/stats?days=${days}`);

export const unbanAutoBlockEvent = (id, resetEscalation = true) =>
  fail2banRequest('post', `auto-block/events/${id}/unban`, { resetEscalation });

export const unbanAndWhitelistEvent = (id) =>
  fail2banRequest('post', `auto-block/events/${id}/whitelist`, {});

export const getAutoBlockHealth = () =>
  fail2banRequest('get', 'auto-block/health');

export const triggerAutoBlockReconcile = () =>
  fail2banRequest('post', 'auto-block/reconcile', {});
